var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIconTasksInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 16.0498H9.10832C8.73332 16.0498 8.42499 15.7414 8.42499 15.3664C8.42499 14.9914 8.73332 14.6831 9.10832 14.6831H16.6667C17.0417 14.6831 17.35 14.9914 17.35 15.3664C17.35 15.7498 17.0417 16.0498 16.6667 16.0498Z",
    fill: "#A9B1C7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 10.8086H9.10832C8.73332 10.8086 8.42499 10.5002 8.42499 10.1252C8.42499 9.75023 8.73332 9.44189 9.10832 9.44189H16.6667C17.0417 9.44189 17.35 9.75023 17.35 10.1252C17.35 10.5002 17.0417 10.8086 16.6667 10.8086Z",
    fill: "#A9B1C7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 5.55856H9.10832C8.73332 5.55856 8.42499 5.25023 8.42499 4.87523C8.42499 4.50023 8.73332 4.19189 9.10832 4.19189H16.6667C17.0417 4.19189 17.35 4.50023 17.35 4.87523C17.35 5.25023 17.0417 5.55856 16.6667 5.55856Z",
    fill: "#A9B1C7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.09166 6.69144C3.90833 6.69144 3.73333 6.61644 3.60833 6.49144L2.84999 5.73311C2.58333 5.46644 2.58333 5.03311 2.84999 4.76644C3.11666 4.49977 3.54999 4.49977 3.81666 4.76644L4.09166 5.04144L5.87499 3.25811C6.14166 2.99144 6.57499 2.99144 6.84166 3.25811C7.10833 3.52477 7.10833 3.95811 6.84166 4.22477L4.57499 6.49144C4.44166 6.61644 4.27499 6.69144 4.09166 6.69144Z",
    fill: "#A9B1C7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.09166 11.9414C3.91666 11.9414 3.74166 11.8748 3.60833 11.7414L2.84999 10.9831C2.58333 10.7164 2.58333 10.2831 2.84999 10.0164C3.11666 9.74977 3.54999 9.74977 3.81666 10.0164L4.09166 10.2914L5.87499 8.50811C6.14166 8.24144 6.57499 8.24144 6.84166 8.50811C7.10833 8.77477 7.10833 9.20811 6.84166 9.47477L4.57499 11.7414C4.44166 11.8748 4.26666 11.9414 4.09166 11.9414Z",
    fill: "#A9B1C7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.09166 16.9414C3.91666 16.9414 3.74166 16.8748 3.60833 16.7414L2.84999 15.9831C2.58333 15.7164 2.58333 15.2831 2.84999 15.0164C3.11666 14.7498 3.54999 14.7498 3.81666 15.0164L4.09166 15.2914L5.87499 13.5081C6.14166 13.2414 6.57499 13.2414 6.84166 13.5081C7.10833 13.7748 7.10833 14.2081 6.84166 14.4748L4.57499 16.7414C4.44166 16.8748 4.26666 16.9414 4.09166 16.9414Z",
    fill: "#A9B1C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIconTasksInactive);
export default __webpack_public_path__ + "static/media/menu_icon_tasks_inactive.bacaef568f584035f3aacf89909e266a.svg";
export { ForwardRef as ReactComponent };